export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Administracja": "Administration",
        "Akceptuj": "Accept",
        "Aktywne": "Active",
        "Aktywne kanały komunikacji": "Active communication channels",
        "Anuluj": "Cancel",
        "Bazowy adres domenowy": "Base domain address",
        "Bieżące powiadomienie w panelu użytkownika.": "Current notification in user panel.",
        "Błąd w kodzie MJML.": "Error in MJML code.",
        "Brak dostępnych kanałów.": "No channels available.",
        "Brak informacji o kluczach tego typu powiadomienia.": "No information about keys for this type of notification.",
        "Centrum powiadomień": "Notification center",
        "Data utworzenia": "Creation date",
        "Data wysłania": "Send date",
        "Dodaj szablon": "Add template",
        "Dodaj wiadomość": "Add message",
        "Dodane przez": "Added by",
        "Domyślna stopka": "Default footer",
        "Domyślne logo": "Default logo",
        "Dostosuj treść dla tego kanału.": "Customize content for this channel.",
        "Edytuj": "Edit",
        "Edytuj komunikaty": "Edit messages",
        "Edytuj szablon": "Edit template",
        "Edytuj wiadomość": "Edit message",
        "Element został usunięty.": "Item has been deleted.",
        "Filtry zmieniają wynik obiektu. Połącz je z obiektem znakiem pionowej kreski.": "Filters modify object output. Combine them with object using a vertical bar.",
        "HTML": "HTML",
        "ID": "ID",
        "Informacje o powiadomieniu": "Notification information",
        "Jak działa wysyłka powiadomień?": "How are notifications sent?",
        "Kanał może korzystać z konfiguracji domyślnej lub własnej treści. Aby edytować tytuł i treść, wyłącz „Konfiguracja domyślna” i rozwiń jego kartę. Wybór języka przy tytule i treści jest zsynchronizowany. Kanałów wymaganych nie można wyłączyć.": "A channel can use default configuration or custom content. To edit title and content, turn off “Default configuration” and expand its card. Language selection for title and content is synchronized. Required channels cannot be turned off.",
        "Kanały": "Channels",
        "Kanały niedostępne wyłączają odpowiednią kolumnę w tabeli.": "Unavailable channels disable the corresponding column in the table.",
        "Kanały wiadomości": "Message channels",
        "Klucze": "Keys",
        "Kod MJML jest poprawny.": "MJML code is valid.",
        "Konfiguracja domyślna": "Default configuration",
        "Konfiguracja kanałów": "Channel configuration",
        "Konfiguracja treści kanałów": "Channel content configuration",
        "Konfigurowalne przez użytkownika": "Configurable by user",
        "Kopiuj HTML": "Copy HTML",
        "Krótka wiadomość tekstowa na telefon.": "Short text message on a phone.",
        "Liquid": "Liquid",
        "Lista jest pusta": "List is empty",
        "Logo osadzane w treści wiadomości mailowych.": "Logo embedded in email message content.",
        "Moje szablony": "My templates",
        "Nazwa": "Name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa pozwalająca rozpoznać wysyłkę na liście. Tytuły wiadomości dla odbiorców ustawisz osobno w poszczególnych kanałach.": "Name used to identify a send in the list. Set message titles for recipients separately in each channel.",
        "Nazwa szablonu": "Template name",
        "Nie można go wyłączyć dla wymaganych kanałów.": "Cannot be turned off for required channels.",
        "Nie udało się pobrać powiadomień.": "Failed to fetch notifications.",
        "Nie udało się skopiować kodu HTML.": "Failed to copy HTML code.",
        "Nie udało się wykonać akcji": "Failed to perform action",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nowy szablon": "New template",
        "np. Kod promocyjny z newslettera": "e.g. Newsletter promo code",
        "Obiekty przechowują treść wyświetlaną w szablonie. Zapisuj je w podwójnych nawiasach klamrowych.": "Objects store content displayed in template. Write them using double curly braces.",
        "Obsługiwane kanały": "Supported channels",
        "Określ kanały wysyłki i treść tego typu powiadomienia.": "Specify delivery channels and content for this notification type.",
        "Określ tytuł, odbiorcę i termin wysłania.": "Specify title, recipient, and send time.",
        "Pełna dokumentacja": "Full documentation",
        "Poczta wychodząca": "Outgoing mail",
        "Pod spodem": "Below",
        "Podgląd": "Preview",
        "Popraw błędy formularza przed zapisaniem.": "Fix form errors before saving.",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Powiadomienia": "Notifications",
        "Powiadomienia mailowe": "Email notifications",
        "Powiadomienie jest aktywne": "Notification is active",
        "Powiadomienie niewidoczne w ustawieniach użytkownika": "Notification not visible in user settings",
        "Powiadomienie push na urządzeniu odbiorcy.": "Push notification on recipient's device.",
        "Powiadomienie testowe zostało wysłane.": "Test notification has been sent.",
        "Powiadomienie w Microsoft Teams.": "Microsoft Teams notification.",
        "Powiadomienie wymagane": "Required notification",
        "Powiadomienie wymagane - nie można wyłączyć go globalnie ani w ustawieniach użytkownika.": "Required notification - cannot be turned off globally or in user settings.",
        "Powiadomienie wymagane.": "Required notification.",
        "Powiadomienie zbiorowe zostało dodane.": "Bulk notification has been added.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Bulk notification has been updated.",
        "Przywróć domyślne": "Restore defaults",
        "Przywrócono ustawienia domyślne.": "Default settings restored.",
        "Skopiowano HTML do schowka.": "HTML copied to clipboard.",
        "Status": "Status",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status powiadomienia": "Notification status",
        "Stopka dla wersji": "Footer for version",
        "Stopkę ustawiasz osobno dla każdej wersji językowej, logo jest wspólne.": "Set footer separately for each language version; logo is shared.",
        "Strona główna": "Home",
        "System": "System",
        "System powiadomień": "Notification system",
        "System szablonów wykorzystuje język Liquid do parsowania treści.": "Template system uses Liquid language to parse content.",
        "Szablon został dodany.": "Template has been added.",
        "Szablon został usunięty.": "Template has been deleted.",
        "Szablon został zaktualizowany.": "Template has been updated.",
        "Szablony email": "Email templates",
        "Szukaj powiadomienia": "Search notifications",
        "Tagi tworzą logikę i sterują przepływem szablonu. Same nie generują widocznej treści.": "Tags create logic and control template flow. They do not generate visible content on their own.",
        "Temat wiadomości widoczny w skrzynce odbiorcy.": "Message subject visible in recipient's inbox.",
        "Ten kanał jest wymagany": "This channel is required",
        "Ten kanał korzysta z domyślnej konfiguracji.": "This channel uses default configuration.",
        "Ten kanał korzysta z domyślnej konfiguracji. W tej wiadomości nie można zmienić jego treści ani włączyć lub wyłączyć wysyłki.": "This channel uses default configuration. You cannot change its content or turn sending on or off for this message.",
        "Ten kanał korzysta z domyślnej konfiguracji. Wyłącz „Konfiguracja domyślna”, aby edytować jego tytuł i treść.": "This channel uses default configuration. Turn off “Default configuration” to edit its title and content.",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel can send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel cannot send formatted text.",
        "Ten kanał obsługuje tekst sformatowany.": "This channel supports rich text.",
        "Ten kanał obsługuje wyłącznie zwykły tekst.": "This channel supports plain text only.",
        "Ten typ powiadomienia jest ukryty w ustawieniach użytkownika - użytkownik nie może sam zmienić jego konfiguracji.": "This notification type is hidden in user settings - user cannot change its configuration.",
        "Testuj": "Test",
        "Treść": "Content",
        "Typ powiadomienia": "Notification type",
        "Typ techniczny": "Technical type",
        "Typy powiadomień": "Notification types",
        "Tytuł": "Title",
        "Tytuł powiadomienia": "Notification title",
        "Tytuł wiadomości dla tego kanału.": "Message title for this channel.",
        "Układ podglądu": "Preview layout",
        "Ustawienia": "Settings",
        "Ustawienia powiadomień zostały zaktualizowane.": "Notification settings have been updated.",
        "Ustawienia wiadomości": "Message settings",
        "Usuń": "Delete",
        "Użytkownik może samodzielnie wybrać dostępne kanały.": "User can select available channels.",
        "Wczytywanie": "Loading",
        "Wersje": "Versions",
        "Wiadomość dostępna w historii powiadomień.": "Message available in notification history.",
        "Wiadomość wysyłana pocztą e-mail.": "Message sent by email.",
        "Widoczne dla użytkownika": "Visible to user",
        "Włącznik wysyłki wszystkich powiadomień.": "Switch for sending all notifications.",
        "Włączony": "Enabled",
        "Własny tytuł i treść dla tego kanału.": "Custom title and content for this channel.",
        "Wpisz powyżej kod MJML, aby wygenerować podgląd.": "Enter MJML code above to generate a preview.",
        "Wszystko": "All",
        "Wybierz kanały wysyłki i dostosuj treść wiadomości dla każdego z nich.": "Select delivery channels and customize message content for each.",
        "Wybierz rolę lub zespół odbiorców oraz termin wysyłki. Możesz użyć kilku kanałów jednocześnie - rozwiń je, aby uzupełnić tytuł i treść w dostępnych językach. Pole „Wysyłaj” włącza kanał, z wyjątkiem kanałów wymaganych. Przed zapisaniem sprawdź odbiorców i przygotowane wiadomości.": "Select a recipient role or team and send time. You can use several channels at once - expand them to fill in title and content in available languages. The “Send” field enables a channel, except for required channels. Check recipients and prepared messages before saving.",
        "Wybierz rolę lub zespół, do którego użytkowników ma trafić wiadomość.": "Select a role or team whose users should receive the message.",
        "Wybierz statusy oraz kanały wysyłki dla poszczególnych powiadomień.": "Select statuses and delivery channels for each notification.",
        "wybierz...": "select...",
        "Wygląd wiadomości wysyłanych kanałem mailowym.": "Appearance of messages sent by email channel.",
        "Wyłączone": "Disabled",
        "Wyłączone powiadomienie nie będzie wysyłane.": "Disabled notification will not be sent.",
        "Wyłączony": "Disabled",
        "Wymagane": "Required",
        "Wymaganego powiadomienia nie można wyłączyć w ustawieniach.": "Required notification cannot be disabled in settings.",
        "Wymagany": "Required",
        "Wymagany do prawidłowego osadzenia logo w treści wiadomości.": "Required for proper embedding of logo in message content.",
        "Wyślij do": "Send to",
        "Wysyłaj": "Send",
        "Wysyłka tym kanałem jest obowiązkowa i nie można jej wyłączyć dla tej wiadomości. Możesz dostosować tytuł oraz treść komunikatu w dostępnych językach. Przed zapisaniem sprawdź, czy każda wersja zawiera właściwe informacje dla odbiorców.": "Sending via this channel is mandatory and cannot be disabled for this message. You can customize the title and message content in available languages. Before saving, check that each version contains the right information for recipients.",
        "Wysyłka tym kanałem jest obowiązkowa i nie można jej wyłączyć. Po wyłączeniu konfiguracji domyślnej możesz dostosować tytuł oraz treść w dostępnych językach. Przed zapisaniem sprawdź przygotowane wersje komunikatu.": "Sending via this channel is mandatory and cannot be disabled. After disabling default configuration, you can customize the title and content in available languages. Before saving, check the prepared message versions.",
        "Wysyłka wiadomości": "Message delivery",
        "Z boku": "On the side",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz ustawienia": "Save settings",
        "Zdarzenia i kanały": "Events and channels",
        "Zmiana hasła": "Password change",
        "Źródło szablonu": "Template source"
    }
};
